import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { getAuthenticated } from '../../selectors';


const propTypes = exact({
  component: PropTypes.any.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,

  exact: PropTypes.bool,
  path: PropTypes.string,
  location: PropTypes.any,
  computedMatch: PropTypes.any,
});


// https://reacttraining.com/react-router/web/example/auth-workflow
const PrivateRoute = (props) => {
  const { component: Component, isAuthenticated, ...rest } = props;

  const renderer = (wrappedProps) => {
    const { location } = wrappedProps;
    if (isAuthenticated) {
      return <Component {...wrappedProps} />;
    }

    return <Redirect to={{ pathname: '/login', state: location }} />;
  };

  return <Route {...rest} render={renderer} />;
};


PrivateRoute.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    isAuthenticated: getAuthenticated(state),
  };
};


const enhance = connect(mapStateToProps, {});


export default enhance(PrivateRoute);
